import { PropertyType } from "@justhome/api-core";
import { useTranslation } from "react-i18next";

export const usePropertyTypeLabel = () => {
  const { t } = useTranslation();
  return {
    APARTMENT: t("typeOfProperty.apartment"),
    SINGLE_FAMILY_HOUSE: t("typeOfProperty.singleFamilyHouse"),
    APARTMENT_BUILDING: t("typeOfProperty.apartmentBuilding"),
    LAND_PLOT: t("typeOfProperty.landPlot"),
  } as Record<PropertyType, string>;
};
